var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"btn",style:({background: _vm.color, padding:_vm.padding}),attrs:{"dark":""}},[_c('v-icon',{style:({padding:_vm.padding})},[_vm._v(_vm._s(_vm.icon))]),_vm._v(_vm._s(_vm.msg))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-daa2be60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V2LOYALTY_REDESIGN/MyComponent.vue
// module id = null
// module chunks = 